import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CONTACT_LABELS, ContactLabelType, LocalOffice, LocalOfficeContact } from '../../../../core/store/admin/local-office/local-office.interface';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-edit-local-office',
  templateUrl: './edit-local-office.component.html',
  styleUrls: ['./edit-local-office.component.scss']
})
export class EditLocalOfficeComponent implements OnInit {

  form: FormGroup;
  @Input() localOffice: LocalOffice;
  @Input() saving = false;

  @Output() cancelClicked = new EventEmitter<void>();
  @Output() saveClicked = new EventEmitter<LocalOffice>();

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.buildForm();
  }

  get contactForms(): FormGroup[] {
    return (this.form.get('contacts') as FormArray).controls as FormGroup[];
  }
  private buildForm() {
    const buildControlForm = (contact: LocalOfficeContact) => {
      return this.fb.group({
        enabled: contact.enabled,
        id: contact.id,
        label: contact.label,
        email: contact.email,
        phoneNumber: contact.phoneNumber,
      })
    }

    this.form = this.fb.group({
      contacts: this.fb.array(CONTACT_LABELS.map(label => buildControlForm(this.getContact(label)))),
    });
  }

  private getContact(label: ContactLabelType): LocalOfficeContact  {
    let contact = this.localOffice.contacts.find(contact => contact.label === label);
    if (!contact) {
      contact = {
        id: null,
        label,
        phoneNumber: '',
        email: '',
        enabled: false,
      }
    } else {
      contact.enabled = true;
    }
    return contact;
  }

  save() {
    this.saveClicked.emit({
      ...this.localOffice,
      contacts: this.form.value.contacts,
    })
  }
}
